import * as React from 'react';
import styles from './ProjectSearch.module.css'
import TypeSelect from "./TypeSelect";
import {PluginApiContext} from "../services/PluginApi";
import Project from "../types/Project";
import {Pin20Regular as Pin} from "@fluentui/react-icons";

interface ProjectSearchProps {
    fileEmail?: (project: Project) => void;
    pinProject?: (project: Project) => void;
    isLoading?: boolean;
    setIsLoading?: (state: boolean) => void;
    selectCount: number;
}

interface ProjectDropDownItemProps {
    project: Project;     
    fileEmail?: (project: Project) => void;
    pinProject?: (project: Project) => void;
}

const ProjectDropDownItem = ({project, fileEmail, pinProject}: ProjectDropDownItemProps) => <>
    <div className={styles.jobDropDownItem}>
        <div className={styles.jobDropDownItemText} onClick={() => fileEmail(project)}>
            <span className={styles.jobNumber}>{project.number}</span>
            <span className={styles.jobName}>{project.name}</span>
        </div>
        <div className={`${styles.toolButton}`}>
            <Pin className={styles.icon}
                 onClick={() => pinProject(project)}/>
        </div>
    </div>
    
</>


const ProjectSearch = ({fileEmail, pinProject, isLoading, setIsLoading, selectCount}: ProjectSearchProps) => {

    const api = React.useContext(PluginApiContext);
    const [projects, setProjects] = React.useState<Project[]>([]);
    const abortControllersRef = React.useRef<AbortController[]>([]);

    const onChange = async (text: string) => {
        const searchText = text.trim();
        if (searchText) {
            // abort all previous searches
            for (let controller of abortControllersRef.current)
                controller.abort();
            abortControllersRef.current.length = 0;
            
            if (setIsLoading) setIsLoading(true);
            
            // create abort controller and run search
            const controller = new AbortController();
            abortControllersRef.current.push(controller);
            const {aborted, projects} = await api.searchProjects(text, 10, controller.signal);
            
            // if not aborted, update projects
            if (!aborted) {
                setProjects(projects);
                if (setIsLoading) setIsLoading(false);
            }
        } else
            setProjects([]);
    }

    const dropDownItems = projects.map(p =>
        <li key={`${p.id}`} className={styles.jobDropDownItemText}>
            <ProjectDropDownItem 
                project={p}
                fileEmail={fileEmail}
                pinProject={pinProject}
            />
        </li>)

    const noItems =
        <li key={'noItems'} className={styles.emptyListItem}>
            <span>Couldn't find any projects</span>
        </li>
    
    const label = SelectedEmailsLabel(selectCount);

    return <>
        <div className={styles.label}>
            {label}
        </div>
        <div className={styles.container}>
            <TypeSelect
                isLoading={isLoading}
                placeholder={"Job name or number ..."}
                onChange={onChange}
                emptyState={noItems}>
                {dropDownItems}
            </TypeSelect>
        </div>
    </>
};

const SelectedEmailsLabel = (count: number) => {
    let countStr = count.toString();

    if (count == 0)
        return "No selected emails";
    else if (count == 1)
        countStr = "one";
    else if (count == 2)
        countStr = "two";
    else if (count == 3)
        countStr = "three";
    else if (count == 4)
        countStr = "four";
    else if (count == 5)
        countStr = "five";
    else if (count == 6)
        countStr = "six";
    else if (count == 7)
        countStr = "seven";
    else if (count == 8)
        countStr = "eight";
    else if (count == 9)
        countStr = "nine";

    const s = count <= 1 ? "" : "s";

    return `File ${countStr} email${s} to:`;
}

export default ProjectSearch;